import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/arrow-right-up.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Send", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Important"),
    /*#__PURE__*/_createTextVNode(": Additional step required to complete Ethereum-bound transactions. You must return to the transaction page to claim funds. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "underline",
      href: "https://docs.nomad.xyz/token-bridge/how-to-bridge#completing-a-transfer-ethereum-destination-only",
      target: "_blank"
    }, " Learn more "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "open",
      class: "mt-1 cursor-pointer"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row justify-center items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2" }, "Checking availability", -1 /* HOISTED */)
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_popconfirm = _resolveComponent("n-popconfirm")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Note: pop confirm is only shown when using nomad and\n  the destination network has manual processing turned on "),
    (_ctx.showConfirmPopup)
      ? (_openBlock(), _createBlock(_component_n_popconfirm, {
          key: 0,
          onPositiveClick: _ctx.send,
          "negative-button-props": { quaternary: true }
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_nomad_button, {
              primary: "",
              class: "w-full flex justify-center h-11 mt-4 uppercase bg-white text-black"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onPositiveClick"]))
      : (_openBlock(), _createBlock(_component_nomad_button, {
          key: 1,
          primary: "",
          disabled: _ctx.disableSend,
          class: "w-full flex justify-center h-11 mt-4 uppercase bg-white text-black",
          onClick: _ctx.send
        }, {
          default: _withCtx(() => [
            (_ctx.protocol === 'connext' && !_ctx.quote)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_n_spin, {
                    stroke: "rgba(0,0,0,0.5)",
                    size: "small"
                  })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "Send"))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "onClick"]))
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}